var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaterIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "007-desktop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M32 43.9844H28V39.9688H20V43.9844H16C14.896 43.9844 14 44.884 14 45.9923C14 47.1006 14.896 48.0001 16 48.0001H32C33.106 48.0001 34 47.1006 34 45.9923C34 44.884 33.106 43.9844 32 43.9844Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M44.5 7.84302H42.88C42.46 9.20835 41.9 10.5536 41.24 11.8587H44V35.9528H4V11.8587H7.76C7.96 10.915 8.42 10.0516 9.12 9.3489C9.66 8.80678 10.26 8.28474 10.92 7.84302H3.5C1.58 7.84302 0 9.42921 0 11.3567V36.4548C0 38.3823 1.58 39.9685 3.5 39.9685H44.5C46.42 39.9685 48 38.3823 48 36.4548V11.3567C48 9.42921 46.42 7.84302 44.5 7.84302Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M39.78 0.357984C39.588 0.165231 39.302 0.0548 39.054 0.0648392C33.4 0.171255 26.804 3.4842 22.616 8.297C18.086 8.45762 14.304 9.82898 11.946 12.1962C11.69 12.4532 11.592 12.8287 11.69 13.1781C11.788 13.5294 12.068 13.7985 12.42 13.8828L16.678 14.9068L16.652 14.9349C16.296 15.3305 16.312 15.9388 16.688 16.3163L23.882 23.5385C24.076 23.7353 24.332 23.8317 24.59 23.8317C24.83 23.8317 25.068 23.7473 25.258 23.5747L25.286 23.5486L26.306 27.8233C26.39 28.1767 26.658 28.4577 27.008 28.5561C27.098 28.5822 27.188 28.5943 27.28 28.5943C27.542 28.5943 27.796 28.4919 27.988 28.3011C30.348 25.9319 31.712 22.1371 31.874 17.5873C36.674 13.3688 39.968 6.75497 40.074 1.08482C40.078 0.813765 39.972 0.550737 39.78 0.357984Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M13.5039 20.838C12.1619 22.1852 10.4439 27.7811 10.1139 28.8894C10.0079 29.2428 10.1059 29.6263 10.3639 29.8873C10.5539 30.0781 10.8099 30.1805 11.0719 30.1805C11.1679 30.1805 11.2639 30.1664 11.3599 30.1383C12.4639 29.807 18.0359 28.0843 19.3799 26.735C20.9999 25.1086 20.9999 22.4643 19.3799 20.8359C17.7559 19.2096 15.1219 19.2116 13.5039 20.838Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laterIcon.59bb8c3f6a629a63bcbff0e57998a663.svg";